module.exports = __webpack_public_path__ + "img/hemline upper pocket position.c5a5d143.png";